import React, { useMemo } from 'react';
import { useBeaconFilters } from 'src/components/BeaconV2Components/ExperimentalLayout/Forecasts/serverProxy/useBeaconFilters';
import UnstyledButton from 'src/components/BeaconV2Components/ExperimentalLayout/Topics/TopicBuilder/components/UnstyledFilterButton';
import { Text } from 'src/components/BeaconV2Components/Generic/Text';
import { useCategoryEntity } from 'src/utils/Hooks/reduxSelectors';
import { useAppFilterModalStore } from 'src/zustandStores/BeaconPro/AppFilterStore';

export default function SubtitleFilters({ showFilterNumber = true }: { showFilterNumber?: boolean }) {
  const { hasActiveFilters, appFilters } = useBeaconFilters();
  const { isCategoryEntity } = useCategoryEntity();

  const { openModal } = useAppFilterModalStore();
  const totalFilters = useMemo(() => {
    const categoryFilterCount = appFilters?.categoryFilters?.length || 0;
    const subcategoryFilterCount = appFilters?.subcategoryFilters?.length || 0;
    let businessUnitFilterCount = appFilters?.businessUnitFilters?.length || 0;

    const segmentFilter = appFilters?.segmentFilters?.id ? 1 : 0;

    // Exclude the main entity business unit from the count
    if (businessUnitFilterCount) {
      businessUnitFilterCount -= 1;
    }

    let totalFilterNumber = categoryFilterCount + subcategoryFilterCount + businessUnitFilterCount + segmentFilter;

    // If the main entity is a category or subcategory, we need to subtract one from the total filter number because entity category is not a filter
    if (isCategoryEntity) {
      totalFilterNumber -= 1;
    }

    return totalFilterNumber;
  }, [appFilters, isCategoryEntity]);

  if (!hasActiveFilters) {
    return <></>;
  }

  const renderText = totalFilters === 1 || !showFilterNumber ? 'Edit filter' : `Edit ${totalFilters} filters`;

  return (
    <>
      {' '}
      <UnstyledButton style={{ display: 'inline', whiteSpace: 'nowrap' }}>
        <Text sx={{ display: 'inline' }} underlined variant="body1" onClick={() => openModal()}>
          {renderText}
        </Text>
        <Text sx={{ display: 'inline' }} variant="body1">
          .
        </Text>
      </UnstyledButton>
    </>
  );
}
